import {InjectionToken} from "@angular/core";
import {AppModuleConfiguration} from "./app-module-configuration";

export const APP_MODULE_CONFIGURATION = new InjectionToken<AppModuleConfiguration>("app-module-configuration");
